import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/app.css";

function showUpdateNotice() {
  if (document.getElementById("dh-next-update-notice")) return;
  const notice = document.createElement("div");
  notice.id = "dh-next-update-notice";
  notice.setAttribute("role", "status");
  notice.setAttribute("aria-live", "assertive");
  notice.innerHTML = `
    <div>
      <span aria-hidden="true">↻</span>
      <strong>Nueva actualización disponible</strong>
      <small>Estamos cargando las mejoras de Delivery Huaraz…</small>
    </div>`;
  document.body.appendChild(notice);
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", { scope: "/" })
      .then((registration) => {
        registration.addEventListener("updatefound", () => {
          const worker = registration.installing;
          if (!worker || !navigator.serviceWorker.controller) return;
          showUpdateNotice();
          worker.addEventListener("statechange", () => {
            if (worker.state === "installed") showUpdateNotice();
          });
        });
        registration.update();

        const refreshWorker = () => registration.update().catch(() => {});
        window.addEventListener("online", refreshWorker);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") refreshWorker();
        });
      })
      .catch(() => {});
  });

  let refreshingForWorker = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshingForWorker) return;
    refreshingForWorker = true;
    showUpdateNotice();
    window.setTimeout(() => window.location.reload(), 500);
  });
}
